// src/App.js
import './App.css';

// ⭐ Components (Header, Footer, Popup)
import Header from './components/Header';
import Footer from './components/Footer';
import ContactPopup from "./components/ContactPopup";
import './VisitedFix.css';


import React, { useState } from "react";

// ⭐ Pages
import Gears from "./pages/gears/Gears";
import Neo from './pages/gears/Neo';
import MavicPro from './pages/gears/MavicPro';
import InstaX2 from './pages/gears/InstaX2';
import InstaX3 from './pages/gears/InstaX3';
import InstaX4 from './pages/gears/InstaX4';
import GoPro8 from './pages/gears/GoPro8';
import GoPro9 from './pages/gears/GoPro9';
import DjiPocket from './pages/gears/DjiPocket';
import GoproMax from './pages/gears/GoproMax';
import ProgramasAfiliados from './pages/ProgramasAfiliados';



import MapPage from './pages/map/MapPage';  
import TravelInsights from './pages/TravelInsights';
import FollowFacebook from './components/FollowFacebook';
import FollowInstagram from './components/FollowInstagram';
import USA from './pages/usa/USA';
import Colorado from './pages/usa/colorado/Colorado';
import Aspen from "./pages/usa/colorado/Aspen";
import Idaho from "./pages/usa/idaho/Idaho";
import BuenaVista from "./pages/usa/colorado/BuenaVista";
import CanyonCity from "./pages/usa/colorado/CanyonCity";
import GrandLake from './pages/usa/colorado/GrandLake';
import Nevada from "./pages/usa/Nevada";
import OregonCoast from './pages/usa/OregonCoast';
import OregonColumbiaRiver from './pages/usa/OregonColumbiaRiver';
import OregonSilverFalls from './pages/usa/OregonSilverFalls';
import Utah from './pages/usa/Utah';
import SouthDakota from './pages/usa/SouthDakota';
import Wyoming from './pages/usa/Wyoming';
import Arizona from './pages/usa/Arizona';
import PuertoRico from './pages/usa/puertorico/PuertoRico';
import Aguadilla from './pages/usa/puertorico/Aguadilla';
import Arecibo from './pages/usa/puertorico/Arecibo';
import CaboRojo from './pages/usa/puertorico/CaboRojo';
import Utuado from './pages/usa/puertorico/Utuado';
import Jayuya from './pages/usa/puertorico/Jayuya';
import ColoradoSprings from './pages/usa/colorado/ColoradoSprings';
import Frisco from './pages/usa/colorado/Frisco';
import GeorgeTown from './pages/usa/colorado/GeorgeTown';
import Breckenridge from './pages/usa/colorado/Breckenridge';
import Golden from './pages/usa/colorado/Golden';
import GlenwoodSprings from './pages/usa/colorado/GlenwoodSprings';
import Morrison from './pages/usa/colorado/Morrison';
import Mosca from './pages/usa/colorado/Mosca';
import Ouray from './pages/usa/colorado/Ouray';
import Rifle from './pages/usa/colorado/Rifle';
import Steamboat from './pages/usa/colorado/Steamboat';
import Telluride from './pages/usa/colorado/Telluride';
import Vail from './pages/usa/colorado/Vail';
import ManitouSprings from './pages/usa/colorado/ManitouSprings';
import Fruita from './pages/usa/colorado/Fruita';
import Denver from './pages/usa/colorado/Denver';
import IdahoSprings from './pages/usa/colorado/IdahoSprings';
import CapeMay from './pages/usa/CapeMay';
import Isabela from './pages/usa/puertorico/Isabela';
import Lajas from './pages/usa/puertorico/Lajas';
import SanJuan from './pages/usa/puertorico/SanJuan';
import Vieques from './pages/usa/puertorico/Vieques';
import RinAguAsco from './pages/usa/puertorico/RinAguAsco';
import Adjuntas from './pages/usa/puertorico/Adjuntas';
import SanSebastian from './pages/usa/puertorico/SanSebastian';
import Guanica from './pages/usa/puertorico/Guanica';
import './VisitedFix.css';







// -------------------------------------------------------------
// ⭐ FUTURE COLORADO SUB‑PAGE IMPORTS (ALL COMMENTED OUT)
// -------------------------------------------------------------
/*
// import Morrison from "./pages/usa/colorado/Morrison";
// import Vail from "./pages/usa/colorado/Vail";
// import Aspen from "./pages/usa/colorado/Aspen";
// import Golden from "./pages/usa/colorado/Golden";
// import Leadville from "./pages/usa/colorado/Leadville";
// import Mosca from "./pages/usa/colorado/Mosca";
// import Denver from "./pages/usa/colorado/Denver";
// import Lakewood from "./pages/usa/colorado/Lakewood";
*/

// -------------------------------------------------------------
// ⭐ FUTURE PUERTO RICO SUB‑PAGE IMPORTS (ALL COMMENTED OUT)
// -------------------------------------------------------------
/*
// import Arecibo from "./pages/usa/PuertoRico/Arecibo";
*/

import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";

function App() {

  // ⭐ Popup state — used for the email popup on the homepage
  const [open, setOpen] = useState(false);

  return (
    <Router>
      <Routes>

        {/* ⭐ HOMEPAGE ROUTE */}
        <Route
          path="/"
          element={
            <div className="App">
              <Header />

              <div className="hero-image">
                <img src="/images/sanddunes.jpg" alt="Sand Dunes" />
              </div>


              <div className="intro-container">
                <div className="homepage-box">
                  <h2>Welcome to The Finding Spot...</h2>

                  <p>
                    I created this page to share my personal experiences while visiting new places—whether it’s scenic drives, hikes, or outdoor adventures—and to highlight the cameras and gear I rely on along the way.
                  </p>

                  <p>
                    The content is divided into two sections: one focused on reviews, experiences, and descriptions of destinations, and the other on the gear I use for travel, photography, and exploration.
                  </p>

                  <p>
                    Each post reflects my humble opinion and includes facts gathered from publicly available sources.
                  </p>
                </div>

                <div className="button-row">       {/* Please Start here */}
  <Link className="main-button" to="/gear">Gear Reviews</Link>
  <Link className="main-button" to="/travel">Travel Insights</Link>
  <Link className="main-button" to="/affiliate-programs">Affiliate Programs</Link>
</div>
{/* ⭐ SOCIAL ICONS UNDER THE 3 BUTTONS */}
<div
  style={{
    display: "flex",
    justifyContent: "center",
    gap: "12px",
    marginTop: "15px",
  }}
>
  <FollowFacebook />
  <FollowInstagram />
</div>



</div>

{/* Centered email button */}
<div className="email-wrapper">
  <button
    className="email-link"
    onClick={() => setOpen(true)}
  >
    contact@thefindingspot.com
  </button>
</div>

{/* Popup */}
<ContactPopup
  isOpen={open}
  onClose={() => setOpen(false)}
/>

<Footer />
</div>
}
        />
{/* ========================================= */}
{/* 🌎 TRAVEL INSIGHTS + WORLD MAP */}
{/* ========================================= */}
<Route path="/travel" element={<TravelInsights />} />
<Route path="/map/:region" element={<MapPage />} />
<Route path="/travel/map" element={<TravelInsights />} />
<Route path="/affiliate-programs" element={<ProgramasAfiliados />} />

{/* ========================================= */}
{/* 🇺🇸 USA MAIN PAGE */}
{/* ========================================= */}
<Route path="/usa" element={<USA />} />
<Route path="/gear" element={<Gears />} />
<Route path="/gear/neo" element={<Neo />} />
<Route path="/gear/mavicpro" element={<MavicPro />} />
<Route path="/gear/instax2" element={<InstaX2 />} />
<Route path="/gear/instax3" element={<InstaX3 />} />
<Route path="/gear/instax4" element={<InstaX4 />} />
<Route path="/gear/gopro8" element={<GoPro8 />} />
<Route path="/gear/gopro9" element={<GoPro9 />} />
<Route path="/gear/gopromax" element={<GoproMax />} />
<Route path="/gear/djipocket" element={<DjiPocket />} />

{/* ========================================= */}
{/* 🇺🇸 OTHER U.S. STATES */}
{/* ========================================= */}
<Route path="/travel/idaho" element={<Idaho />} />
<Route path="/travel/nevada" element={<Nevada />} />
<Route path="/travel/oregoncoast" element={<OregonCoast />} />
<Route path="/travel/oregoncolumbiariver" element={<OregonColumbiaRiver />} />
<Route path="/travel/oregonsilverfalls" element={<OregonSilverFalls />} />
<Route path="/travel/utah" element={<Utah />} />
<Route path="/travel/southdakota" element={<SouthDakota />} />
<Route path="/travel/wyoming" element={<Wyoming />} />
<Route path="/travel/arizona" element={<Arizona />} />
<Route path="/travel/capemay" element={<CapeMay />} />

{/* ========================================= */}
{/* 🇺🇸 COLORADO (REGION) */}
{/* ========================================= */}
<Route path="/travel/usa/colorado" element={<Colorado />} />

{/* ========================================= */}
{/* 🇺🇸 COLORADO — CITIES & TOWNS (FIXED) */}
{/* ========================================= */}
<Route path="/travel/usa/colorado/aspen" element={<Aspen />} />
<Route path="/travel/usa/colorado/buenavista" element={<BuenaVista />} />
<Route path="/travel/usa/colorado/canyoncity" element={<CanyonCity />} />
<Route path="/travel/usa/colorado/coloradosprings" element={<ColoradoSprings />} />
<Route path="/travel/usa/colorado/frisco" element={<Frisco />} />
<Route path="/travel/usa/colorado/georgetown" element={<GeorgeTown />} />
<Route path="/travel/usa/colorado/golden" element={<Golden />} />
<Route path="/travel/usa/colorado/glenwoodsprings" element={<GlenwoodSprings />} />
<Route path="/travel/usa/colorado/morrison" element={<Morrison />} />
<Route path="/travel/usa/colorado/mosca" element={<Mosca />} />
<Route path="/travel/usa/colorado/ouray" element={<Ouray />} />
<Route path="/travel/usa/colorado/rifle" element={<Rifle />} />
<Route path="/travel/usa/colorado/steamboat" element={<Steamboat />} />
<Route path="/travel/usa/colorado/telluride" element={<Telluride />} />
<Route path="/travel/usa/colorado/vail" element={<Vail />} />
<Route path="/travel/usa/colorado/manitousprings" element={<ManitouSprings />} />
<Route path="/travel/usa/colorado/denver" element={<Denver />} />
<Route path="/travel/usa/colorado/idahosprings" element={<IdahoSprings />} />
<Route path="/travel/usa/colorado/fruita" element={<Fruita />} />
<Route path="/travel/usa/colorado/breckenridge" element={<Breckenridge />} />
<Route path="/travel/usa/colorado/grandlake" element={<GrandLake />} />

{/* ========================================= */}
{/* 🇵🇷 PUERTO RICO (REGION) */}
{/* ========================================= */}
<Route path="/travel/puertorico" element={<PuertoRico />} />

{/* ========================================= */}
{/* 🇵🇷 PUERTO RICO — MUNICIPALITIES */}
{/* ========================================= */}
<Route path="/travel/puertorico/aguadilla" element={<Aguadilla />} />
<Route path="/travel/puertorico/arecibo" element={<Arecibo />} />
<Route path="/travel/puertorico/caborojo" element={<CaboRojo />} />
<Route path="/travel/puertorico/utuado" element={<Utuado />} />
<Route path="/travel/puertorico/jayuya" element={<Jayuya />} />
<Route path="/travel/puertorico/isabela" element={<Isabela />} />
<Route path="/travel/puertorico/lajas" element={<Lajas />} />
<Route path="/travel/puertorico/sanjuan" element={<SanJuan />} />
<Route path="/travel/puertorico/vieques" element={<Vieques />} />
<Route path="/travel/puertorico/rincon" element={<RinAguAsco section="rincon" />} />
<Route path="/travel/puertorico/aguada" element={<RinAguAsco section="aguada" />} />
<Route path="/travel/puertorico/anasco" element={<RinAguAsco section="anasco" />} />
<Route path="/travel/puertorico/adjuntas" element={<Adjuntas />} />
<Route path="/travel/puertorico/sansebastian" element={<SanSebastian />} />
<Route path="/travel/puertorico/guanica" element={<Guanica />} />




     


        
       
        
        

        {/* ------------------------------------------------------------- */}
        {/* ⭐ FUTURE COLORADO SUB‑PAGE ROUTES (ALL COMMENTED OUT) */}
        {/* ------------------------------------------------------------- */}
        {/*
        <Route path="/travel/colorado/morrison" element={<Morrison />} />
        <Route path="/travel/colorado/vail" element={<Vail />} />
        <Route path="/travel/colorado/aspen" element={<Aspen />} />
        <Route path="/travel/colorado/golden" element={<Golden />} />
        <Route path="/travel/colorado/leadville" element={<Leadville />} />
        <Route path="/travel/colorado/mosca" element={<Mosca />} />
        <Route path="/travel/colorado/denver" element={<Denver />} />
        <Route path="/travel/colorado/lakewood" element={<Lakewood />} />
        */}

        {/* ------------------------------------------------------------- */}
        {/* ⭐ FUTURE PUERTO RICO SUB‑PAGE ROUTES (ALL COMMENTED OUT) */}
        {/* ------------------------------------------------------------- */}
        {/*
        <Route path="/travel/puertorico/arecibo" element={<Arecibo />} />
        */}

        {/* ⭐ GEAR PAGE */}
        <Route
          path="/gear"
          element={
            <div className="App">
              <Header />
              <div className="intro-container">
                <h2>Gear Page Coming Soon</h2>
              </div>
              <Footer />
            </div>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;
